// Public pages are cached and never read the session cookie, so the header
// can't know who is signed in. The server sets a readable `lgp_signed_in=1`
// cookie next to the httponly session cookie and deletes it on sign out.
// The header renders both sets of links; this shows the signed-in set
// ([data-auth="in"]) and hides the signed-out one ([data-auth="out"]: Pricing,
// Blog, Sign in). It grants nothing: /app still checks the real session.
export const HINT_COOKIE = 'lgp_signed_in'

export function isSignedIn(cookie: string = document.cookie): boolean {
  return cookie.split(';').some((part) => part.trim() === `${HINT_COOKIE}=1`)
}

export function applySessionHint(root: ParentNode = document, cookie: string = document.cookie): void {
  const signedIn = isSignedIn(cookie)
  root.querySelectorAll<HTMLElement>('[data-auth]').forEach((el) => {
    el.hidden = (el.dataset.auth === 'in') !== signedIn
  })
}
